import { Link } from 'react-router-dom';
import { Heart, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import useQuranStore from '../store/quranStore';

export default function SurahCard({ surah, index }) {
  const { isFavorite, addFavorite, removeFavorite } = useQuranStore();
  const surahNo = index + 1;
  const isFav = isFavorite(surahNo);

  const handleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isFav) {
      removeFavorite(surahNo);
    } else {
      addFavorite({
        surahNo,
        surahName: surah.surahName,
        surahNameArabic: surah.surahNameArabic,
      });
    }
  };

  return (
    <Link to={`/surah/${surahNo}`} data-testid={`surah-card-${surahNo}`}>
      <div className="group relative bg-card rounded-xl border border-t-2 border-t-primary/30 p-5">
        {/* Surah number badge - octagram star */}
        <div className="absolute -top-3 -left-2 verse-number">
          <span className="text-sm font-semibold text-primary">{surahNo}</span>
        </div>

        {/* Favorite button */}
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-2 right-2"
          onClick={handleFavorite}
          data-testid={`favorite-btn-${surahNo}`}
        >
          <Heart className={`w-4 h-4 ${isFav ? 'fill-red-500 text-red-500' : ''}`} />
        </Button>

        {/* Content */}
        <div className="mt-4">
          {/* Arabic name */}
          <h3 className="font-arabic text-2xl text-right mb-2 text-foreground">
            {surah.surahNameArabic}
          </h3>
          
          {/* English name and translation */}
          <div className="flex items-start justify-between gap-2">
            <div>
              <h4 className="font-semibold text-foreground">{surah.surahName}</h4>
              <p className="text-sm text-muted-foreground">{surah.surahNameTranslation}</p>
            </div>
          </div>

          {/* Meta info */}
          <div className="flex items-center justify-between mt-4 pt-3 border-t border-border/50">
            <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
              <MapPin className="w-3 h-3" />
              {surah.revelationPlace}
            </div>
            <span className="text-xs text-muted-foreground">
              {surah.totalAyah} Ayahs
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
